import {Box, Button, Menu, MenuItem, Typography} from '@mui/material';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import {useState} from 'react';

interface SingleSelectProps<T> {
  options: Map<T, string>;
  selectedKey: T | undefined;
  onClick: (newKey: T) => void;
  placeholder?: string;
  align?: 'left' | 'right';
  dataTestId?: string;
  prefixLabel?: string;
  elevation?: number;
}

export const SingleSelect = <T extends string>({
  options,
  selectedKey,
  onClick,
  placeholder = '',
  align = 'left',
  dataTestId,
  prefixLabel,
  elevation = 1,
}: SingleSelectProps<T>) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <Box>
      <Button
        color="inherit"
        size="small"
        endIcon={<ArrowDropDownIcon />}
        onClick={handleClick}
        data-testid={dataTestId}
      >
        {prefixLabel && (
          <Typography variant="body2" pr={1}>
            {prefixLabel}
          </Typography>
        )}
        <Typography variant="body2">{selectedKey ? (options.get(selectedKey) ?? '') : placeholder}</Typography>
      </Button>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        style={{zIndex: 3000}}
        anchorOrigin={{horizontal: align, vertical: 'bottom'}}
        transformOrigin={{horizontal: align, vertical: 'top'}}
        elevation={elevation}
      >
        {Array.from(options.keys()).map((optionKey) => (
          <MenuItem
            key={optionKey}
            onClick={() => {
              handleClose();
              onClick(optionKey);
            }}
            selected={optionKey === selectedKey}
            data-testid={optionKey}
          >
            {options.get(optionKey) ?? ''}
          </MenuItem>
        ))}
      </Menu>
    </Box>
  );
};
